export enum RoleLevels {
  OPEN = 'OPEN',
  GUEST= 'GUEST',
  MEMBER = 'MEMBER',
  ADMIN = 'ADMIN',
  OWNER = 'OWNER',
}

export type TypeofRoleLevel = keyof typeof RoleLevels;
